import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';

import type { ItilTranslationStatus } from '../types';
import { itilColors } from '../styles';

const statusStyles: Record<
  ItilTranslationStatus,
  { bg: string; color: string; dot: string }
> = {
  idle: { bg: '#eef1f5', color: '#8a94a4', dot: '#b3bdcb' },
  loading: { bg: '#fbf0d8', color: itilColors.warn, dot: '#d79a2b' },
  ready: { bg: '#e3f3ea', color: itilColors.ok, dot: itilColors.ok },
  stale: { bg: '#fbe6df', color: itilColors.req, dot: itilColors.req },
  error: { bg: '#fdeceb', color: '#b3261e', dot: '#b3261e' },
  skipped: { bg: '#eef1f5', color: '#6b7686', dot: '#9aa4b2' },
  storedAsOriginal: { bg: '#eef1f5', color: '#6b7686', dot: '#9aa4b2' }
};

type Props = {
  status: ItilTranslationStatus;
};

function ItilStatusBadge({ status }: Props) {
  const { t } = useTranslation('global');
  const style = statusStyles[status];

  return (
    <Chip
      label={t(`itilGenius.status.${status}`)}
      size="small"
      sx={{
        ml: 'auto',
        height: 22,
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.03em',
        textTransform: 'uppercase',
        bgcolor: style.bg,
        color: style.color,
        '& .MuiChip-label': { px: 1 },
        '&::before': {
          content: '""',
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: style.dot,
          mr: 0.5,
          animation: status === 'loading' ? 'itil-pulse 1s infinite' : 'none'
        },
        '@keyframes itil-pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.3 }
        }
      }}
    />
  );
}

export default ItilStatusBadge;
